import { AfterViewInit, Component, Renderer2 } from '@angular/core';
import { BrandingService } from './shared/branding/branding.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit {
  constructor(
    private renderer: Renderer2,
    private readonly branding: BrandingService
  ) {}

  ngAfterViewInit() {
    const loader = this.renderer.selectRootElement('#loader-alphastar-app');
    this.renderer.setStyle(loader, 'display', 'none');
    this.renderer.setAttribute(
      document.documentElement,
      'data-brand',
      this.branding.brand.id
    );
  }
}
